import { BreadCrumb } from "primereact/breadcrumb"
import { MenuItem } from "primereact/menuitem"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useAppSelector } from "../../../stateManagement/hooks/redux"
import { setSidebarMenuPath } from "../../../stateManagement/reducers/SidebarBlockSlice"
import { getItemWebStorage, setItemWebStorage } from "../../../features/webStorageSaver"

const homeIconSrc = require('../../../assets/images/icons/home_icon.svg').default

export default function Breadcrumbs() {
    const dispatch = useDispatch()
    const currentMenuStructure = useAppSelector(state => state.sidebar.sidebarMenuStructure)
    const currentMenuPath = useAppSelector(state => state.sidebar.sidebarMenuPath)
    const [breadcrumbsModel, setBreadcrumbsModel] = useState<any>([])

    function resetCurrentMenuPath() {
        const newMenuPath: any = []
        dispatch(setSidebarMenuPath(newMenuPath))
        const sidebarLocalSettings = getItemWebStorage('sidebar')
        const newSidebarSettings = {
            ...sidebarLocalSettings,
            menuPath: newMenuPath
        }
        setItemWebStorage('sidebar', newSidebarSettings)
    }

    function changeCurrentMenuPathBreadcrumbs(event: any) {
        const { breadcrumbsIndex } = event?.item?.data
        const newMenuPath = currentMenuPath.slice(0, breadcrumbsIndex + 1)
        dispatch(setSidebarMenuPath(newMenuPath))
        const sidebarLocalSettings = getItemWebStorage('sidebar')
        const newSidebarSettings = {
            ...sidebarLocalSettings,
            mewnuPath: newMenuPath
        }
        setItemWebStorage('sidebar', newSidebarSettings)
    }

    function configureBreadcrumbsModel() {
        let model: Array<MenuItem> = []
        currentMenuPath.reduce((menuStructure: any, menuStructureIndex: any, index: any) => {
            const menuItem = menuStructure[menuStructureIndex]
            const modelItem = {
                label: menuItem.title,
                data: {
                    breadcrumbsIndex: index,
                },
                command: (event: any) => changeCurrentMenuPathBreadcrumbs(event)
            }
            model.push(modelItem)
            return menuStructure[menuStructureIndex].children
        }, currentMenuStructure)
        setBreadcrumbsModel(model)
    }

    useEffect(() => {
        if (currentMenuPath && currentMenuStructure) {
            configureBreadcrumbsModel()
        }
    }, [currentMenuPath, currentMenuStructure])

    return (
        <div className="breadcrumbs-div">
            <div className="home-button-div" onClick={resetCurrentMenuPath}>
                <img src={homeIconSrc} className="home-button-image" />
            </div>
            <div className="breadcrumbs-list">
                <BreadCrumb model={breadcrumbsModel} />
            </div>
        </div>
    )
}
